import { createAction, props } from '@ngrx/store';

import { PickId } from '../../core/picks/pick-id';
import { BetslipTypesActions } from '../types/actions';
import { IComboBetPickState } from './state';

export default class BetslipComboBetActions {
    static readonly ACTION_SCHEMA = `${BetslipTypesActions.ACTION_SCHEMA}/combo-bet`;

    private static readonly ADD_PICK = `${BetslipComboBetActions.ACTION_SCHEMA}/ADD_PICK`;
    private static readonly REMOVE_PICK = `${BetslipComboBetActions.ACTION_SCHEMA}/REMOVE_PICK`;
    private static readonly REPLACE_PICK = `${BetslipComboBetActions.ACTION_SCHEMA}/REPLACE_PICK`;
    private static readonly SET_COMBO_BET_REWARD_TOKEN = `${BetslipComboBetActions.ACTION_SCHEMA}/SET_COMBO_BET_REWARD_TOKEN`;
    private static readonly SET_COMBO_BET_STAKE = `${BetslipComboBetActions.ACTION_SCHEMA}/SET_COMBO_BET_STAKE`;
    private static readonly SET_COMBO_BET_EACH_WAY = `${BetslipComboBetActions.ACTION_SCHEMA}/SET_COMBO_BET_EACH_WAY`;
    private static readonly LINEAR_PICK_LIST_VISIBILITY_SWITCH = `${BetslipComboBetActions.ACTION_SCHEMA}/LINEAR_PICK_LIST_VISIBILITY_SWITCH`;
    private static readonly TOGGLE_COMBO_BET_PICK = `${BetslipComboBetActions.ACTION_SCHEMA}/TOGGLE_COMBO_BET_PICK`;
    private static readonly ADD_PICK_WITH_NEW_PICKID = `${BetslipComboBetActions.ACTION_SCHEMA}/ADD_PICK_WITH_NEW_PICKID`;

    static setComboEachWay = createAction(BetslipComboBetActions.SET_COMBO_BET_EACH_WAY, props<{ isEachWay: boolean }>());
    static linearPickListVisibilitySwitch = createAction(
        BetslipComboBetActions.LINEAR_PICK_LIST_VISIBILITY_SWITCH,
        props<{ positionEvent: string; eventDetails: string }>(),
    );

    static setComboBetRewardToken = createAction(
        BetslipComboBetActions.SET_COMBO_BET_REWARD_TOKEN,
        props<{ rewardTokenId: string | null; ignoreAccaBoost?: boolean }>(),
    );

    static setComboBetStake = createAction(
        BetslipComboBetActions.SET_COMBO_BET_STAKE,
        props<{ stake: number | null; silent?: boolean; stakeStr?: string }>(),
    );

    static addPick = createAction(BetslipComboBetActions.ADD_PICK, props<{ pickId: string; pickState: Partial<IComboBetPickState> }>());
    static removePick = createAction(BetslipComboBetActions.REMOVE_PICK, props<{ pickId: string }>());
    static replacePick = createAction(BetslipComboBetActions.REPLACE_PICK, props<{ oldPIckId: string; newPickId: string }>());

    static toggleComboBetPick = createAction(BetslipComboBetActions.TOGGLE_COMBO_BET_PICK, props<{ pickId: PickId }>());

    static addPickWithNewPickId = createAction(BetslipComboBetActions.ADD_PICK_WITH_NEW_PICKID);
}
